import React from 'react';
import styled from 'styled-components';

import { SkeletonBlock } from '@/components/common';

const HistoryTableSkeleton = (): React.ReactElement => <SkeletonContent />;

export { HistoryTableSkeleton };

const SkeletonContent = styled(SkeletonBlock)`
  min-height: 100px;
`;
